import { TICKETING_PROVIDERS } from '@terra/shared-contracts-knowledge-sync';
import type { TicketingProviderType } from '@terra/shared-contracts-knowledge-sync';

export type TicketingWorkItemKind = 'issue' | 'incident';

export const getTicketingWorkItemKind = ({
  provider,
}: {
  provider: TicketingProviderType;
}): TicketingWorkItemKind =>
  provider === TICKETING_PROVIDERS.SERVICENOW ? 'incident' : 'issue';
